export default __webpack_public_path__ + "static/media/8_Gesteinslawine.c617145d.png";